import { reskinStyles } from '../theme-variant';
const overrideRadio = (theme) => {
  theme.overrides.MuiRadio = {
    ...reskinStyles(theme, {
      colorPrimary: { '&$checked': { color: theme.colors.selection_control } },
      colorSecondary: { '&$checked': { color: theme.colors.selection_control } }
    }),
    root: {
      color: theme.colorPalette.green_75,
      padding: 4,
      // Reskin: neutral unselected rings, so green doesn't compete with the bark selection.
      ...reskinStyles(theme, { color: theme.colorPalette.beige_90 })
    },
    disabled: {
      color: theme.colors.white
    }
  };
};

export default overrideRadio;
